import { useState } from "react";
import { createModel } from "hox";
import useStorageState from "../hooks/useStorageState";
import { PaginationProps } from "antd/es/pagination";
import { ISelectOption } from "@/components/YhFormBox/Types";
import { IPgProps, ISelectOptions } from "@/types/AppTypes";
import { commonService } from '@/service/common'
import { IVRMWarehouseDetail } from "@/views/base/warehouseManage/warehouseTypes";
import { warehouseService } from "@/views/base/warehouseManage/warehouseService";
import { userControlService } from "@/views/base/userControl/userControlService";

export function transPgToPagination(pg: IPgProps): PaginationProps {
    return {
        total: pg.total,
        pageSize: pg.size,
        current: pg.current
    }
}
export function transPgToPaginationTotal(pg: IPgProps): PaginationProps {
    return {
        total: pg.total,
        pageSize: pg.size,
        current: pg.current
    }
}

export function fn(): Promise<ISelectOption[]> {
    let arr: ISelectOption[] = [];
    return Promise.resolve(arr)
}

export type RoleType = {
    id: string,
    name: String,
};
export type UserType = {
    id: string,
    userName: string,
    password: String,
    token: string,
    shopId: string,
    shopName: string,
    shopCode: string,
    loginType?: "account" | "token"
    [key: string]: any
}

export type ShopAndOrgType = {
    orgCode: string,
    orgName: string
}

export type LoadingType = { loadingVisible: boolean, txt: string };

type GlobalModelType = {
    user: UserType,
    setUser: (e: UserType) => void,
    resetUser: () => void,
    toggleMenu: () => void,
    cm: CmType,
    resetCm: () => void,
    loadingInfo: LoadingType,
    setLoadingInfo: (origin: LoadingType) => void,

    whDs: ISelectOptions[],
    // warehouseloadDataAll: (shopCode?: string) => void,

    beDs: ISelectOptions[],
    setBeDs: (value: ISelectOptions[] | ((previousState?: ISelectOptions[] | undefined) => ISelectOptions[])) => void
    // beLoadDataAll: () => void,
    requestCacheAll: (shopCode?: string) => void,

    shopDs: ISelectOptions[],
    setShopDs: (origin: ISelectOptions[]) => void

    userList: ISelectOptions[],
    setuserList: (origin: ISelectOptions[]) => void

    userOrgList: ISelectOptions[],
    setUserOrgList: (origin: ISelectOptions[]) => void

    userData: ISelectOptions[],
    setuserData: (origin: ISelectOptions[]) => void
    warehouseList: ISelectOptions[],
    setWarehouseList: (origin: ISelectOptions[]) => void

    supplierDs: ISelectOptions[],
    // supplierLoadDataAll: (shopCode?: string) => void,


    resourceAuth: string[],
    setResourceAuth: (origin: string[]) => void

    menuAuth: string[],
    setMenuAuth: (origin: string[]) => void,

    shopAndOrg: ShopAndOrgType,
    setShopAndOrg: (e: ShopAndOrgType) => void,
    resetShopAndOrg: () => void,
    fetchUserList: (e: string) => void,
    // fetchCustomerList: (value: string) => Promise<ISelectOption[]>,
    // fetchSupplierList: (value: string) => Promise<ISelectOption[]>,
    // fetchOfferList: (value: string) => Promise<ISelectOption[]>,
    // fetchSalesList: (value: string) => Promise<ISelectOption[]>,
    // fetchSaleBySupplier: (value: string) => Promise<ISelectOption[]>,
};


const initUserState = {
    id: "",
    userName: "",
    password: "",
    token: "",
    shopId: "",
    shopName: "",
    shopCode: "",
}
const initShopAndOrg = {
    orgCode: "yh",
    orgName: "云豪集团",

}
type CmType = {
    collapsed: boolean
}
const initCmState = {
    collapsed: false
}

function useModel(): GlobalModelType {
    //所有仓库
    const [whDs, setwhDs] = useStorageState<ISelectOptions[]>("gtm.waerhouseDs", []);
    //经营实体
    const [beDs, setBeDs] = useStorageState<ISelectOptions[]>("beDs", []);
    //所有门店
    const [shopDs, setShopDs] = useStorageState<ISelectOptions[]>("gtm.shopDs", []);
    //用户所有菜单权限
    const [menuAuth, setMenuAuth] = useStorageState<string[]>("gtm.user.menus", []);
    //用户所有资源权限
    const [resourceAuth, setResourceAuth] = useStorageState<string[]>("gtm.user.resource", []);
    //用户所有信息
    const [user, setUser, resetUser] = useStorageState<UserType>('gtm.user', initUserState);
    const [userList, setuserList] = useStorageState<ISelectOptions[]>('userList', []);
    const [userOrgList, setUserOrgList] = useStorageState<ISelectOptions[]>('userOrgList', []);
    const [userData, setuserData] = useStorageState<ISelectOptions[]>('userData', []);
    const [shopAndOrg, setShopAndOrg, resetShopAndOrg] = useStorageState<ShopAndOrgType>('shopAndOrgNews', initShopAndOrg);
    // //所有供应商
    const [supplierDs, setSupplierDs] = useStorageState<ISelectOptions[]>("gtm.supplierDs", []);
    const [cm, setCm, resetCm] = useStorageState<CmType>('gtm.cm', initCmState);
    //仓库数据
    const [warehouseList, setWarehouseList] = useStorageState<ISelectOptions[]>("warehouseList", []);
    //全局loading
    const [loadingInfo, setLoadingInfo] = useState<LoadingType>({ loadingVisible: false, txt: "" });

    const toggleMenu = () => {
        setCm({
            ...cm,
            collapsed: !cm.collapsed
        })
    }
    //初始页数
    const searchParams = { pageSize: -1, pageNum: 1 };

    //实时查询客户接口
    // const fetchCustomerList = async (value: string) => {
    //     // if (!value) return await fn();
    //     let data = { pageSize: -1, pageNum: 1,  name: value?.trim()};
    //     return customerService.page(data).then(res => {
    //         const { retData: { records } } = res;
    //         return records ? records.map((item:any) => ({
    //             key: item.id,
    //             id: item.id,
    //             label: item.customerName,
    //             value: item.id,
    //             phone: item.customerPhone??'',  //联系电话
    //             contact: item.customerCorporation??'', //联系人
    //             address: item.customerAddress??'',   //联系地址
    //         })) : [];
    //     })
    // }



    // 实时查询用户接口
    const fetchUserList = async (value: string) => {
        // if (!value) return await fn();
        let data = {
            page: {
                pageSize: -1,
                pageNum: 1,
            },
            sourceApp: 'portal',
            orgCode: value,
            status: 0
        }
        let { retData } = await userControlService.orgPage(data)
        const { records, ...pg } = retData
        setuserData(records?.map((item) => ({
            label: item.name,
            value: item.code,
            id: item.id,
        })));
    }


    // //初始所有用户
    const loadUserAll = async () => {
        const searchParams = {
            page: {
                pageSize: -1,
                pageNum: 1,
            },
            sourceApp: 'portal',
            status: 0
        }
        let { retData } = await userControlService.page(searchParams)
        const { records, ...pg } = retData
        setuserList(records?.map((item) => ({
            label: item.name,
            value: item.code,
            code: item.code,
            id: item.id,
            orgName: item.orgName,
            orgCode: item.orgCode,
        })));
    }
    const loadUserOrgAll = async () => {
        const searchParams = {
            page: {
                pageSize: -1,
                pageNum: 1,
            },
            sourceApp: 'portal',
            status: 0
        }
        let { retData } = await userControlService.page(searchParams)
        const { records, ...pg } = retData
        setUserOrgList(records?.map((item) => ({
            label: `${item.name}(${item.orgName})`,
            value: item.code,
            name: item.name,
            code: item.code,
            id: item.id,
            orgName: item.orgName,
            orgCode: item.orgCode,
        })));
    }
    // //初始所有实体
    const beloadDataAll = async () => {
        let { retData } = await commonService.bePage({});
        setBeDs(retData.map((item) => ({
            label: item.name,
            value: item.id,
            id: item.id,
            phone: item.phone,
            address: item.address
        })));
    }
    //初始所有仓库
    const loadWarehouseAllData = async () => {
        const params = {
            pageSize: 10000,
            pageNum: 1,
        }
        let { retData } = await warehouseService.page(params);
        const { records, ...pg } = retData;
        const newRecords = records.map(item => ({
            // ...item,
            // // code: item.id,
            // // codes: item.code
            label: (item.name as string),
            value: item.code,
            id: item.id,
        }))
        setWarehouseList(newRecords)
    }


    //所有缓存加载
    const requestCacheAll = (shopId = user.shopId) => {
        beloadDataAll();
        loadWarehouseAllData()
        loadUserAll()
        loadUserOrgAll()
    };

    return {
        user, setUser, resetUser,
        cm, toggleMenu, resetCm,
        loadingInfo, setLoadingInfo,
        whDs,
        requestCacheAll,
        supplierDs,
        // beDs,
        userList, setuserList,
        beDs, setBeDs,
        shopDs, setShopDs,
        resourceAuth, setResourceAuth,
        menuAuth, setMenuAuth,
        shopAndOrg, setShopAndOrg, resetShopAndOrg,
        warehouseList,
        setWarehouseList,
        fetchUserList,
        userData,
        setuserData,
        userOrgList, setUserOrgList
        // warehouseloadDataAll,
        // fetchCustomerList,
        // fetchSupplierList,
        // fetchOfferList,
        // fetchSalesList,
        // fetchSaleBySupplier
    };
}

export const useGlobalModel = createModel(useModel)
export default useGlobalModel;
